export default new class PicklistService {
    mergeDynamicFields(pickListInput, dynamicFields) {
        const selectedFields = pickListInput[0]; // selected fields of picklist
        const reducedSelectableFields = dynamicFields.filter((dynamicField) => { // dynamic fields that are not in the selection
            return  !selectedFields.find(field => field.fieldName === dynamicField.fieldName)
        })
        for (const selectedValue of selectedFields) {
            selectedValue.invalid = !dynamicFields.find( // fields that are not in  dynamicFields at all are INVALID
                dynamicField => selectedValue.fieldName === dynamicField.fieldName
            );
        }
        return [selectedFields, reducedSelectableFields];
    }

    filterInvalidContentsFromContent(profileContent){
        profileContent[0] = profileContent[0].filter((content)=>{
            return content.invalid !== true
        })
        return profileContent
    }
}

